<template>
  <div id="notification-button" class="notification-button">
    <button
      @click="notifications = !notifications"
      :style="estilo"
      data-v-step="5"
    >
      <font-awesome-icon icon="bell" />
    </button>
    <div
      id="notification-cant"
      class="notification-cant"
      @click="notifications = !notifications"
    >
      3
    </div>
    <notifications v-if="notifications" v-on:cerrar="cerrarm" />
  </div>
</template>

<script>
import notifications from "../ProyectDetails/notifications";
export default {
  data: () => ({
    notifications: false,
    estilo: "",
  }),
  components: {
    notifications,
  },
  watch: {
    notifications(value) {
      if (value) {
        this.estilo = "color: #fff; background: var(--sixth-color);";
      } else {
        this.estilo = "";
      }
    },
  },
  methods: {
    cerrarm() {
      this.notifications = false;
    },
  },
};
</script>

<style>
.notification-button {
  position: relative;
  margin: 0 10px;
}
.notification-button > button,
.notification-button > .notification-cant {
  color: var(--second-color);
  border-radius: 100%;
  background: var(--third-color);
}
.notification-button > button:active {
  color: #fff;
  background: var(--sixth-color);
}
.notification-button button {
  width: 35px;
  height: 35px;
  font-size: 1.375rem;
  border: none;
  outline: none;
}
.notification-button .notification-cant {
  position: absolute;
  top: -10%;
  left: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  font-size: 0.7rem;
  font-family: PT Sans, sans-serif;
  font-weight: bold;
  box-shadow: 0px 3px 5px 0px rgba(120, 138, 128, 0.8);
}

/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/

@media (max-width: 991px) and (min-width: 768px) {
  .notification-button button {
    width: 60px;
    height: 60px;
    color: var(--third-color);
    background: var(--second-color);
    font-size: 30px;
  }
  .notification-button .notification-cant {
    width: 30px;
    height: 30px;
    color: var(--third-color);
    background: var(--second-color);
  }
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/

@media (max-width: 767px) {
  .notification-button button {
    width: 30px;
    height: 30px;
    color: var(--third-color);
    background: var(--second-color);
  }
  .notification-button .notification-cant {
    width: 20px;
    height: 20px;
    color: var(--third-color);
    background: var(--second-color);
  }
}
</style>